(() => {
  if (window.mmGuaranteeReady) return;
  window.mmGuaranteeReady = true;
  let trigger;
  let previousOverflow;
  const dialog = document.getElementById('mm-guarantee-dialog');
  function prepareReadingView(content) {
    const smallScreen = window.matchMedia('(max-width: 599px)').matches;
    const frame = content.querySelector('.mm-guarantee-image-scroll');
    const zoom = content.querySelector('[data-mm-guarantee-zoom]');
    frame.classList.toggle('is-zoomed', smallScreen);
    zoom.setAttribute('aria-pressed', String(smallScreen));
    zoom.textContent = smallScreen ? 'Gesamte Grafik anzeigen' : 'Grafik vergrößern';
  }
  document.querySelectorAll('.mm-guarantee-content').forEach(prepareReadingView);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-mm-guarantee-open]');
    if (link && dialog && typeof dialog.showModal === 'function' && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault();
      if (dialog.open) return;
      trigger = link;
      previousOverflow = document.body.style.overflow;
      prepareReadingView(dialog.querySelector('.mm-guarantee-content'));
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      dialog.querySelector('.mm-guarantee-dialog__body').scrollTop = 0;
      dialog.querySelector('[data-mm-guarantee-close]').focus({ preventScroll: true });
      return;
    }
    const zoom = event.target.closest?.('[data-mm-guarantee-zoom]');
    if (zoom) {
      const frame = zoom.closest('.mm-guarantee-content').querySelector('.mm-guarantee-image-scroll');
      const enlarged = frame.classList.toggle('is-zoomed');
      zoom.setAttribute('aria-pressed', String(enlarged));
      zoom.textContent = enlarged ? 'Gesamte Grafik anzeigen' : 'Grafik vergrößern';
      if (enlarged) frame.focus({ preventScroll: true });
    }
    if (event.target.closest?.('[data-mm-guarantee-close]')) dialog?.close();
  });
  if (!dialog) return;
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') event.stopPropagation();
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]')].filter(element => element.getClientRects().length);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow ?? '';
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  });
})();
